import { pxToRem } from 'styles/functions'

const theme = {
  logo_height: 100,

  token_hidden: true,
  number_hidden: true,

  button_color: '#434242',
  button_hover_color: '#434242',
  button_hover_text_color: 'white',
  button_hover_border_color: '#434242',
  button_radius: 15,
  button_font: `'Roboto', sans-serif`,

  text_font: `'Roboto', sans-serif`,
  title_font: `'Oswald', sans-serif`,
  title_margin: `${pxToRem(10)} 0 ${pxToRem(10)} ${pxToRem(10)} `
}

// St-Charles-Borromée
export const scb = {
  ...theme,
  logo_image_url: 'scb.svg',
  body_background_color: '#5ac4be',
  title_color: '#5ac4be',
  subtitle_color: '#5ac4be'
}

// Antoine-Lacombe
export const scbAL = {
  ...theme,
  logo_image_url: 'scb2.svg',
  body_background_color: '#f66f62',
  button_color: '#343B48',
  button_hover_color: '#343B48',
  button_hover_border_color: '#343B48',
  title_color: '#f66f62',
  subtitle_color: '#f66f62'
}
